import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PREFIX_PATH = process.env.REACT_APP_PREFIX_PATH || 'page';

// Valid paths that use the prefix path
const VALID_PREFIX_PATHS = [
  '/home',
  '/applications',
  '/reports',
  '/activities',
];

// Regex pattern to match dynamic routes
const DYNAMIC_PATH_PATTERNS = [
  /^\/applications\/[^/]+$/, // /applications/:applicationId
  /^\/applications\/[^/]+\/documents$/, // /applications/:applicationId/documents
  /^\/applications\/[^/]+\/documents\/[^/]+$/, // /applications/:applicationId/documents/:documentId
];

const PrefixRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname;

    // Extract prefix from current path (e.g., /gcash/home -> gcash)
    const pathParts = pathname.split('/').filter(Boolean);
    if (pathParts.length === 0) return;

    const currentPrefix = pathParts[0];

    // Only redirect if current prefix is "gcash" and it differs from expected prefix
    if (currentPrefix !== 'gcash' || currentPrefix === PREFIX_PATH) return;

    // Check if the path after the prefix is a valid path
    const pathWithoutPrefix = '/' + pathParts.slice(1).join('/');

    // Check static paths
    const isStaticPath = VALID_PREFIX_PATHS.includes(pathWithoutPrefix);

    // Check dynamic paths
    const isDynamicPath = DYNAMIC_PATH_PATTERNS.some((pattern) =>
      pattern.test(pathWithoutPrefix)
    );

    // If it's a valid path, redirect to the new prefix
    if (isStaticPath || isDynamicPath) {
      const newPath = `/${PREFIX_PATH}${pathWithoutPrefix}${location.search}${location.hash}`;
      navigate(newPath, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default PrefixRedirect;
